import React, { FC } from 'react';
import COButton from 'shared/components/COButton';
import { OrganizationMapReset } from '.';
import { Col, Row } from 'antd';
import styles from './organisationMapReactFlow.module.scss';

export const MapResetButton: FC<{
  mapRef: React.RefObject<OrganizationMapReset>;
}> = ({ mapRef }) => {
  const resetView = () => {
    if (mapRef.current) {
      mapRef.current.resetView();
    }
  };
  return (
    <Row justify="end">
      <Col className={styles.resetButton}>
        <COButton onClick={resetView} text>
          Reset Map Position
        </COButton>
      </Col>
    </Row>
  );
};
